import type { HelpSlug, HelpTopicDef } from '../types';
import { gettingStarted } from './getting-started';
import { inbox } from './inbox';
import { pcosAndFunding } from './pcos-and-funding';
import { weeklyRollups } from './weekly-rollups';
import { approveAndSend } from './approve-and-send';
import { materials } from './materials';
import { movingBlocks } from './moving-blocks';
import { settingsTopic } from './settings';
import { newProject } from './new-project';
import { howTheMathWorks } from './how-the-math-works';
import { importedHistory } from './imported-history';
import { glossary } from './glossary';
import { troubleshooting } from './troubleshooting';

/**
 * Complete by construction: Record over the closed HelpSlug union means a new
 * slug without content (or vice versa) is a compile error.
 */
export const HELP_TOPICS: Record<HelpSlug, HelpTopicDef> = {
  'getting-started': gettingStarted,
  inbox,
  'pcos-and-funding': pcosAndFunding,
  'weekly-rollups': weeklyRollups,
  'approve-and-send': approveAndSend,
  materials,
  'moving-blocks': movingBlocks,
  settings: settingsTopic,
  'new-project': newProject,
  'how-the-math-works': howTheMathWorks,
  'imported-history': importedHistory,
  glossary,
  troubleshooting,
};

/** Display order on the index page, grouped by HelpGroup at render time. */
export const HELP_ORDER: HelpSlug[] = [
  'getting-started',
  'inbox',
  'moving-blocks',
  'materials',
  'pcos-and-funding',
  'weekly-rollups',
  'approve-and-send',
  'how-the-math-works',
  'imported-history',
  'settings',
  'new-project',
  'glossary',
  'troubleshooting',
];

/** "New to the portal? Start here" strip, in reading order. */
export const START_HERE: HelpSlug[] = [
  'getting-started',
  'inbox',
  'weekly-rollups',
  'approve-and-send',
];

export function getTopic(slug: string): HelpTopicDef | undefined {
  return HELP_TOPICS[slug as HelpSlug];
}
